export default __webpack_public_path__ + "static/media/Telkari of the Riftcaller.9db64b5c.jpg";